import type {ReactNode} from "react";
import {DsButton} from "./DsButton";

export type DsEmptyStateProps = {
  icon?: ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionHref?: string;
  children?: ReactNode;
};

export function DsEmptyState({icon, title, description, actionLabel, onAction, actionHref, children}: DsEmptyStateProps) {
  return (
    <div className="cc-ds-empty">
      {icon ? <div className="cc-ds-empty__icon">{icon}</div> : null}
      <h3 className="cc-ds-empty__title">{title}</h3>
      {description ? <p className="cc-ds-empty__text">{description}</p> : null}
      {children}
      {actionLabel && actionHref ? (
        <div className="cc-ds-empty__actions">
          <a href={actionHref} className="cc-ds-btn cc-ds-btn--primary cc-ds-btn--md">{actionLabel}</a>
        </div>
      ) : null}
      {actionLabel && onAction && !actionHref ? (
        <div className="cc-ds-empty__actions">
          <DsButton onClick={onAction}>{actionLabel}</DsButton>
        </div>
      ) : null}
    </div>
  );
}
